<template>
  <div id="">

<v-container fluid class="pa-0 container-roles">

  <v-row no-gutters>








    <v-col :cols="6">
      <v-toolbar color=" primary darken-3 white--text" dense height="40">
        <v-toolbar-title>
          Roles
        </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text icon color="white" @click="addRol()">
            <v-icon>add</v-icon>
          </v-btn>
      </v-toolbar>
      <v-list two-line tile color="grey lighten-2 list-roles overflow-y-auto" height="300px" :dense="isMobile">
        <template v-for="rol in rolesComputed">

        <v-sheet color="grey lighten-1" class="pa-2" v-if="rol.edit">
          <v-list-item-content>
            <v-row >

              <v-col>
                <v-text-field
                name="Título"
                label="Título"
                v-model="rol.editAttrs.title"
                dense
                hide-details
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                name="Nombre"
                label="Nombre"
                v-model="rol.editAttrs.name"
                dense
                hide-details
                ></v-text-field>
              </v-col>

              <v-col>
                <v-btn text icon color="primary" @click="saveRol(rol)">
                  <v-icon>save</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-sheet>
        <v-list-item v-else :class="{'primary lighten-2 primary--text' : rolSelected == rol }" >
          <v-list-item-content>
            <v-list-item-title>{{rol.title}}</v-list-item-title>
            <v-list-item-subtitle>{{rol.name}}</v-list-item-subtitle>
          </v-list-item-content>
          <v-btn text icon x-small :class="{
            'primary--text text--darken-2' : rolSelected == rol,
            'grey--text text--lighten-2' : rolSelected == rol
            }" @click="editRol(rol)">
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn text icon x-small :class="{
            'primary--text text--darken-2' : rolSelected == rol,
            'grey--text text-lighten--2' : rolSelected == rol
            }" @click="deleteRol(rol)">
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn text icon x-small :class="{
            'primary--text text--darken-2' : rolSelected == rol,
            'grey--text text--lighten-2' : rolSelected == rol
            }" @click="selectRol(rol)">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-list-item>
        </template>
      </v-list>
  </v-col>






    <v-col :cols="6">

      <v-toolbar color=" primary darken-1 white--text" dense height="40">
        <v-toolbar-title>
          Habilidades <span v-if="rolSelected"> de {{rolSelected.name}}</span>
        </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text icon color="white" @click="addAbility()">
            <v-icon>add</v-icon>
          </v-btn>
      </v-toolbar>

      <v-list two-line tile color=" list-roles overflow-y-auto" height="300px" :dense="isMobile">


<template v-for="ability in abilitiesComputed">

        <v-sheet color="grey lighten-1" class="pa-2" v-if="ability.edit">
          <v-list-item-content>
            <v-row >

              <v-col>
                <v-text-field
                name="Título"
                label="Título"
                v-model="ability.editAttrs.title"
                dense
                hide-details
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                name="Nombre"
                label="Nombre"
                v-model="ability.editAttrs.name"
                dense
                hide-details
                ></v-text-field>
              </v-col>

              <v-col>
                <v-btn text icon color="primary" @click="saveAbility(ability)">
                  <v-icon>save</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-sheet>

        <v-list-item v-else>
            <v-list-item-action :class="{'mr-2':isMobile}">
              <v-checkbox :dense="isMobile"
                :disabled="rolSelected == null"
                @change="changeAbility(ability)"
                :value="hasAbility(rolSelected, ability)"
                color="primary"
              ></v-checkbox>
            </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ability.title}}</v-list-item-title>
            <v-list-item-subtitle>{{ability.name}}</v-list-item-subtitle>
          </v-list-item-content>
              <v-btn text icon color="grey" x-small @click="editAbility(ability)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn text icon color="grey" x-small @click="deleteAbility(ability)">
                <v-icon>delete</v-icon>
              </v-btn>
        </v-list-item>
        </template>
      </v-list>
  </v-col>
</v-row>
</v-container>



  </div>
</template>
<script>
import Repository from "@/models/repoIrricrops";
import _ from "lodash";
export default {
  name: "rolesEditor",
  data: () => ({
    roles       : [],
    abilities   : [],
    rolSelected : null,
    newRol      : {
      name      : "",
      title     : "",
      abilities : [],
      edit      : true,
      loading   : false,
      isNew     : true,
            editAttrs: {
              title : "",
              name  : ""
            }
    },
    newAbility:{
      name    : "",
      title   : "",
      edit    : true,
      loading : false,
      isNew   : true,
            editAttrs: {
              title : "",
              name  : ""
            }
    }
  }),
  created(){
    this.getData();
  },
  computed:{
    isMobile(){
      return this.$store.getters.isMobile;
    },
    abilitiesComputed(){
      return _.orderBy(this.abilities, 'title');
    },
    rolesComputed(){
      return _.orderBy(this.roles, 'title');
    },
  },
  methods: {
    getData() {
      this.getRoles();
    },
    getRoles(){
      return Repository.get("rol")
      .then(res => {

        this.roles = _.map(res.data.roles, rol => {
          return {
            ...rol,
            isNew   : false,
            edit    : false,
            loading : false,
            editAttrs: {
              title : rol.title,
              name  : rol.name
            }
          }
        });

        this.abilities= res.data.abilities.map(ab => {
          return {
            ...ab,
            edit: false,
            loading: false,
            isNew: false,
            editAttrs: {
              title : ab.title,
              name  : ab.name
            }
          }
        });

      })
    },
    selectRol(rol){
      this.rolSelected = rol;
    },
    addRol(){
      var rol = _.cloneDeep(this.newRol);
      this.roles.push(rol)
    },
    addAbility(){
      var ab = _.cloneDeep(this.newAbility);
      this.abilities.push(ab);
    },
    editRol(rol){
      rol.edit = true;
    },
    editAbility(ability){
      ability.edit = true;
      this.$forceUpdate();
    },
    hasAbility(rol, ability){
      if(rol && ability){
        var a = _.find(rol.abilities, {title: ability.title, name: ability.name}) !== undefined;
        return a;
      }
      return false;
    },
    changeAbility(ability){
      var abilityFounded = _.find(this.rolSelected.abilities, {title: ability.title, name: ability.name} )
      if(abilityFounded){
        abilityFounded.add = 0;
        //_.remove(this.rolSelected.abilities, ability.id)
      }else{
        //this.rolSelected.abilities.push(ability.id);
        this.rolSelected.abilities.push({
          name  : ability.name,
          title : ability.title,
          add   : 1
        });
      }
      this.saveRol(this.rolSelected);
    },
    saveRol(rol){
      var fn = rol.id ? "put" : "post";
      var route = "rol"+(rol.id ? "/"+rol.id : "");
      return Repository[fn](route, {
          id        : rol.id,
          name      : rol.editAttrs.name,
          title     : rol.editAttrs.title,
          abilities : _.reduce(rol.abilities, (result, ability) => {
            if(ability.add !== undefined){
              result.push({
                name  : ability.name,
                title : ability.title,
                add   : ability.add
              })
            }
            return result;
          }, []),
      })
      .then(res => {
        this.getData();
        /*
        console.dir(res);
        rol.edit = false;
        rol.title = rol.editAttrs.title;
        rol.name  = rol.editAttrs.name;
        _.remove(rol.abilities, {add:0});
        // TODO: alerta de guardado satisfecho
        this.$forceUpdate();
        */

      }, resError =>{
        console.error(resError);
      })
    },
    saveAbility(ability){
      var fn = ability.id ? "put" : "post";
      var route = "ability"+(ability.id ? "/"+ability.id : "");
      return Repository[fn](route, {
          //id    : ability.id,
          name  : ability.editAttrs.name,
          title : ability.editAttrs.title,
      })
      .then(res => {
        this.getData();
        /*
        console.dir(res);
        ability.edit = false;
        ability.title = ability.editAttrs.title;
        ability.name  = ability.editAttrs.name;
        _.forEach(this.roles, rol => {
          var ab   = _.find(rol.abilities, {title: ability.title, name: ability.name});
          if(ab){
            ab.title = ability.editAttrs.title;
            ab.name  = ability.editAttrs.name;
          }
        })
        */
        //this.$forceUpdate();

      }, resError =>{
        console.error(resError);
      })
    },
    deleteRol(rol){
      // TODO: mejorar mensaje
      if(confirm("seguro desea eliminarlo?")){
        return Repository.delete("rol/"+rol.id).then(res => {
          _.remove(this.roles, {title: rol.title});
          this.$forceUpdate();
        }, resError => {
          console.error(resError);
        })
      }
    },
    deleteAbility(ability){
      // TODO: mejorar mensaje
      if(confirm("seguro desea eliminarlo?")){
        return Repository.delete("ability/"+ability.id, {
          id    : ability.id,
        }).then(res => {
          _.remove(this.abilities , {title:ability.title, name: ability.name});
          this.$forceUpdate();
        }, resError => {
          console.error(resError);
        })
      }

    },
  }
}
</script>
<style lang="scss" scoped>
</style>
